import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { cx, hexToRgba } from "shared/utils";
import type { ApplicationStageSummary } from "types/application";

const Chevron = () => (
  <HugeiconsIcon
    icon={ArrowDown01Icon}
    size={12}
    strokeWidth={2}
    className="shrink-0 text-content-500"
  />
);

export const StagePill = ({
  stage,
  className,
  chevron
}: {
  stage: ApplicationStageSummary;
  className?: string;
  chevron?: boolean;
}) => (
  <Badge
    variant={BadgeVariant.BASE}
    size={BadgeSize.SM}
    className={cx("items-center !text-content-1000", className)}
    style={{ backgroundColor: hexToRgba(stage.color, 0.1) }}
    leftElement={
      <span
        className="rounded-full w-2 h-2 mr-1 shrink-0 translate-y-px"
        style={{ backgroundColor: stage.color }}
      />
    }
    rightElement={
      <span className="flex items-center gap-1 whitespace-nowrap">
        {stage.name}
        {chevron ? <Chevron /> : null}
      </span>
    }
  />
);

export const EmptyStagePill = ({ chevron }: { chevron?: boolean }) => (
  <Badge
    variant={BadgeVariant.OUTLINE}
    size={BadgeSize.SM}
    className="items-center border-dashed !text-content-400"
    rightElement={
      <span className="flex items-center gap-1 whitespace-nowrap">
        Set stage
        {chevron ? <Chevron /> : null}
      </span>
    }
  />
);
